<div class="agos-page">

	<header class="topbar">
		<div class="topbar-in">

			<a class="logo" href="https://www.agosrenting.it/" target="_blank" rel="noopener" aria-label="Agos Renting">
				<img src="https://cdn.sgasgas.it/sgasgas/agency/agos/images/LOGO_AgosRenting.png"
					alt="Agos Renting logo">
			</a>

			<div class="progress-wrap">
				<div class="progress-meta">
					<span>Richiesta</span>
					<strong>{{ completionPercent }}%</strong>
				</div>
				<mat-progress-bar mode="determinate" [value]="completionPercent"></mat-progress-bar>
			</div>
		</div>
	</header>

	<div class="page-scroll">
		<section class="hero">
			<div class="hero-in">
				<div *ngIf="!isSubmitted">
					<span class="eyebrow">Fine noleggio</span>
					<h1>Prenota la riconsegna del tuo veicolo</h1>
					<p>
						Il tuo contratto di noleggio sta per concludersi? Indica le tue preferenze e
						<b>ti ricontatteremo per confermare la data</b> dell'appuntamento di riconsegna.
					</p>
				</div>
			</div>
		</section>

		<main class="main-wrap">
			<mat-card class="form-card" *ngIf="!isSubmitted">
				<mat-card-content>
					<form [formGroup]="frm" (ngSubmit)="submit()" (keydown.enter)="onKeydownEnter($event)" novalidate>
						<mat-stepper class="agos-stepper" [linear]="true" #stepper  [class.stepper-disabled]="isCheckingPlateAndContract"
							(selectionChange)="onStepperSelectionChange()">
							<ng-template matStepperIcon="number" let-index="index">
								{{ index + 1 }}
							</ng-template>
							<ng-template matStepperIcon="edit" let-index="index">
								{{ index + 1 }}
							</ng-template>
							<ng-template matStepperIcon="done" let-index="index">
								{{ index + 1 }}
							</ng-template>

							<mat-step [stepControl]="contrattoGroup">
								<ng-template matStepLabel>Contratto e veicolo</ng-template>
								<div class="step-inner" [formGroup]="contrattoGroup">
									<h2>Contratto e veicolo</h2>
									<p>I riferimenti del noleggio da riconsegnare</p>

									<div class="grid">
										<mat-form-field appearance="outline" class="c6" floatLabel="always"
											[class.mat-form-field-invalid]="isInvalid('contrattoStep.contratto') || contractNrAndPlateNotValid"
											[class.ng-invalid]="isInvalid('contrattoStep.contratto') || contractNrAndPlateNotValid"
											[class.ng-touched]="isInvalid('contrattoStep.contratto') || contractNrAndPlateNotValid">
											<mat-label>Numero contratto</mat-label>
											<input matInput formControlName="contratto" autocomplete="off"
												placeholder="Es. AR-2026-01245" (input)="onContractOrPlateInputChanged()"
												(blur)="onContractOrPlateBlur()">
											<mat-error *ngIf="getFieldError('contrattoStep.contratto')">
												{{ getFieldError('contrattoStep.contratto') }}
											</mat-error>

										</mat-form-field>

										<div class="c6 plate-field"
											[ngClass]="{ 'field-err': isInvalid('contrattoStep.targa') || contractNrAndPlateNotValid }">
											<label class="plate-input_label" for="targa">Targa</label>

											<div class="plate">

												<span class="band"><svg>
														<use href="#i-stars" />
													</svg><em>I</em></span>

												<input id="targa" formControlName="targa" required maxlength="7"
													placeholder="AA000AA" autocomplete="off"
													aria-label="Targa del veicolo" spellcheck="false"
													(input)="sanitizeTarga(); onContractOrPlateInputChanged()"
													(blur)="onContractOrPlateBlur()">
												<span class="band"></span>
											</div>

											<small class="req-error" *ngIf="getFieldError('contrattoStep.targa')">
												{{ getFieldError('contrattoStep.targa') }}
											</small>
										</div>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Marca</mat-label>
											<input matInput formControlName="marca" placeholder="Es. Fiat" readonly>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Modello</mat-label>
											<input matInput formControlName="modello"
												placeholder="Es. Pandina 1.0 Hybrid" readonly>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Allestimento</mat-label>
											<input matInput formControlName="allestimento" placeholder="Es. Business"
												readonly>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Telaio</mat-label>
											<input matInput formControlName="telaio" placeholder="Es. VF1XXXXXXXXXXXXXX"
												readonly>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6 readonly-look"
											floatLabel="always">
											<mat-label>Data di fine contratto</mat-label>
											<input matInput [matDatepicker]="picker" formControlName="scadenza"
												readonly>
											<mat-datepicker-toggle matIconSuffix [for]="picker"
												disabled></mat-datepicker-toggle>
											<mat-datepicker #picker></mat-datepicker>
										</mat-form-field>
									</div>

								</div>

								<div class="step-actions">
									<button mat-icon-button class="next-arrow-btn" type="button"
										(click)="onContrattoStepNext(stepper)" aria-label="Continua" title="Continua">
										<mat-icon aria-hidden="true">chevron_right</mat-icon>
									</button>
								</div>
							</mat-step>

							<mat-step [stepControl]="contattiGroup">
								<ng-template matStepLabel>I tuoi dati</ng-template>
								<div class="step-inner" [formGroup]="contattiGroup">
									<h2>I tuoi dati</h2>
									<p>Come possiamo ricontattarti per la conferma</p>

									<div class="grid">
										<mat-form-field appearance="outline" class="c12" floatLabel="always">
											<mat-label>Nome e cognome / Ragione sociale</mat-label>
											<input matInput formControlName="cliente" autocomplete="name">
											<mat-error *ngIf="isInvalid('contattiStep.cliente')">Campo
												obbligatorio</mat-error>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Telefono</mat-label>
											<input matInput formControlName="telefono" type="tel" autocomplete="tel"
												placeholder="+39 ...">
											<mat-error *ngIf="isInvalid('contattiStep.telefono')">Campo
												obbligatorio</mat-error>
										</mat-form-field>

										<mat-form-field appearance="outline" class="c6" floatLabel="always">
											<mat-label>Email</mat-label>
											<input matInput formControlName="email" type="email" autocomplete="email"
												placeholder="nome@esempio.it">
											<mat-error *ngIf="isInvalid('contattiStep.email')">Inserisci una email
												valida</mat-error>
										</mat-form-field>

										<div class="c12 radio-wrap">
											<span class="radio-title">Preferisco essere ricontattato via</span>
											<mat-radio-group formControlName="contattoPreferito" class="inline-radios">
												<mat-radio-button value="Telefono">Telefono</mat-radio-button>
												<mat-radio-button value="Email">Email</mat-radio-button>
												<mat-radio-button value="Indifferente">Indifferente</mat-radio-button>
											</mat-radio-group>
											<small class="radio-error"
												*ngIf="isInvalid('contattiStep.contattoPreferito')">Campo
												obbligatorio</small>
										</div>
									</div>
								</div>

								<div class="step-actions has-prev" style="margin-top: 1rem">
									<button mat-icon-button class="prev-arrow-btn" type="button" matStepperPrevious
										aria-label="Indietro" title="Indietro">
										<mat-icon aria-hidden="true">chevron_left</mat-icon>
									</button>
									<button mat-icon-button class="next-arrow-btn" type="button" aria-label="Continua"
										title="Continua" (click)="onContattiGroupStepNext(stepper)">
										<mat-icon aria-hidden="true">chevron_right</mat-icon>
									</button>
								</div>
							</mat-step>

							<mat-step [stepControl]="appuntamentoGroup">

								<ng-template matStepLabel>Appuntamento</ng-template>

								<div class="step-inner appointment-step" [formGroup]="appuntamentoGroup">

									<h2>Appuntamento di riconsegna</h2>
									<p>Indica quando e dove preferiresti riconsegnare il veicolo</p>

									<div class="dealer-summary">

										<div class="dealer-icon">
											<mat-icon>location_on</mat-icon>
										</div>

										<div class="dealer-content">

											<div class="dealer-title">
												Sede di riconsegna
											</div>

											<div class="dealer-name">
												{{ appuntamentoGroup.get('denominazioneDealer')?.value || '-' }}
											</div>

											<div class="dealer-address">
												{{ appuntamentoGroup.get('indirizzoDealer')?.value || '-' }}
												<br>
												{{ appuntamentoGroup.get('capDealer')?.value }}
												{{ appuntamentoGroup.get('comuneDealer')?.value }}
											</div>

										</div>

									</div>


									<div class="appointment-box">

										<!-- DATA 1 -->
										<div class="appointment-line">

											<mat-form-field appearance="outline" floatLabel="always">
												<mat-label>Data preferita</mat-label>
												<input matInput [matDatepicker]="picker1" [min]="minPreferredDate"
													formControlName="data1">
												<mat-datepicker-toggle matIconSuffix [for]="picker1">
												</mat-datepicker-toggle>
												<mat-datepicker #picker1></mat-datepicker>

												<mat-error
													*ngIf="showAppuntamentoError('appuntamentoStep.data1') && control('appuntamentoStep.data1').hasError('required')">
													Campo obbligatorio</mat-error>
												<mat-error
													*ngIf="showAppuntamentoError('appuntamentoStep.data1') && control('appuntamentoStep.data1').hasError('matDatepickerMin')">
													La data minima e domani</mat-error>
											</mat-form-field>


											<div class="fascia-box">

												<label>Fascia preferita</label>

												<div class="fasce-radio">

													<mat-radio-group formControlName="fascia1">
														<mat-radio-button value="mattina">{{ isMobile ? 'Matt.' :
															'Mattina' }}</mat-radio-button>
														<mat-radio-button value="pomeriggio">{{ isMobile ? 'Pom.' :
															'Pomeriggio' }}</mat-radio-button>
														<mat-radio-button value="indifferente">{{ isMobile ? 'Indiff.' :
															'Indifferente' }}</mat-radio-button>
													</mat-radio-group>

												</div>

												<mat-error
													*ngIf="showAppuntamentoError('appuntamentoStep.fascia1')">Campo
													obbligatorio
												</mat-error>
											</div>
										</div>



										<!-- DATA 2 -->
										<div class="appointment-line">

											<mat-form-field appearance="outline" floatLabel="always">
												<mat-label>Data alternativa</mat-label>
												<input matInput [matDatepicker]="picker2" formControlName="data2">
												<mat-datepicker-toggle matIconSuffix [for]="picker2">
												</mat-datepicker-toggle>
												<mat-datepicker #picker2></mat-datepicker>
											</mat-form-field>


											<div class="fascia-box">
												<label>Fascia alternativa</label>

												<div class="fasce-radio">

													<mat-radio-group formControlName="fascia2">
														<mat-radio-button value="mattina">{{ isMobile ? 'Matt.' :
															'Mattina' }}</mat-radio-button>
														<mat-radio-button value="pomeriggio">{{ isMobile ? 'Pom.' :
															'Pomeriggio' }}</mat-radio-button>
														<mat-radio-button value="indifferente">{{ isMobile ? 'Indiff.' :
															'Indifferente' }}</mat-radio-button>
													</mat-radio-group>

												</div>
											</div>
										</div>

										<!-- DATA 3 -->
										<div class="appointment-line">

											<mat-form-field appearance="outline" floatLabel="always">
												<mat-label>Seconda data alternativa</mat-label>
												<input matInput [matDatepicker]="picker3" formControlName="data3">
												<mat-datepicker-toggle matIconSuffix [for]="picker3">
												</mat-datepicker-toggle>
												<mat-datepicker #picker3></mat-datepicker>
											</mat-form-field>


											<div class="fascia-box">
												<label>Seconda fascia alternativa</label>

												<div class="fasce-radio">

													<mat-radio-group formControlName="fascia3">
														<mat-radio-button value="mattina">{{ isMobile ? 'Matt.' :
															'Mattina' }}</mat-radio-button>
														<mat-radio-button value="pomeriggio">{{ isMobile ? 'Pom.' :
															'Pomeriggio' }}</mat-radio-button>
														<mat-radio-button value="indifferente">{{ isMobile ? 'Indiff.' :
															'Indifferente' }}</mat-radio-button>
													</mat-radio-group>

												</div>
											</div>
										</div>
									</div>

								</div>


								<div class="step-actions has-prev">

									<button mat-icon-button class="prev-arrow-btn" type="button" matStepperPrevious>
										<mat-icon>chevron_left</mat-icon>
									</button>


									<button mat-icon-button class="next-arrow-btn" type="button"
										(click)="onAppuntamentoStepNext(stepper)">
										<mat-icon>chevron_right</mat-icon>
									</button>

								</div>

							</mat-step>

							<mat-step [stepControl]="noteGroup">
								<ng-template matStepLabel>Note e invio</ng-template>
								<div class="step-inner" [formGroup]="noteGroup">
									<h2>Note e invio</h2>
									<p>Un ultimo passaggio e ci pensiamo noi</p>

									<mat-form-field appearance="outline" class="w-full" floatLabel="always">
										<mat-label>Note per l'appuntamento</mat-label>
										<textarea matInput formControlName="note" rows="4"
											placeholder="Es. disponibile solo il venerdi, ritiro a domicilio..."></textarea>
									</mat-form-field>

									<mat-checkbox formControlName="consenso" class="privacy-check">
										Acconsento al trattamento dei dati per la gestione della richiesta secondo
										<a href="https://www.agosrenting.it/privacy.html" target="_blank"
											rel="noopener">informativa privacy</a>.
									</mat-checkbox>

									<small class="error-privacy" *ngIf="isInvalid('noteStep.consenso')">Il consenso è
										obbligatorio per proseguire</small>
								</div>

								<div class="step-actions has-prev">
									<button mat-icon-button class="prev-arrow-btn" type="button" matStepperPrevious
										aria-label="Indietro" title="Indietro">
										<mat-icon aria-hidden="true">chevron_left</mat-icon>
									</button>
									<button mat-flat-button color="primary" class="submit-request-btn" type="submit"
										[disabled]="isSending">
										{{ isSending ? 'Invio in corso...' : 'Invia richiesta' }}
									</button>
								</div>
							</mat-step>
						</mat-stepper>
					</form>
				</mat-card-content>
			</mat-card>

			<mat-card class="recap-card" *ngIf="isSubmitted">

				<mat-card-header class="recap-head">

					<div class="success-icon">
						<mat-icon>check</mat-icon>
					</div>

					<mat-card-title>Richiesta inviata con successo</mat-card-title>

					<mat-card-subtitle>
						Abbiamo ricevuto la tua richiesta. Ti ricontatteremo a breve per confermare l'appuntamento.
					</mat-card-subtitle>

				</mat-card-header>

				<mat-card-content>
					<div class="recap-compact">
						<div class="recap-minihead">Riepilogo dati inviati</div>
						<div class="recap-fields">
							<article class="recap-item" *ngFor="let row of recapA">
								<p class="k">{{ row.key }}</p>
								<p class="v">{{ row.value }}</p>
							</article>
						</div>
					</div>
				</mat-card-content>

				<mat-card-actions align="end" class="recap-actions">
					<button mat-stroked-button type="button" (click)="resetAll()">Invia una nuova richiesta</button>
				</mat-card-actions>
			</mat-card>
		</main>
	</div>
</div>

<div class="popup-backdrop" *ngIf="showDuplicatePopup">

	<div class="popup-box">

		<h3>Attenzione</h3>

		<p>Esiste già una pratica con questa targa e questo contratto.</p>

		<button mat-flat-button color="primary" (click)="closeDuplicatePopup()">OK</button>
	</div>
</div>